<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false" [class]="kymw1709Model.imageFile3 ? 'subwindow' : kymw1709Model.imageFile2 ? 'subwindow subwindow2' : 'subwindow subwindow3'">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アップロード画像確認</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-row">

          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">画像ファイル名</label>
              <div class="list-input-content">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imageFileName1">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imagePixel1">
              </div>
            </div>
            <img id="img_PastImage" src="data:image/{{kymw1709Model.imageFileMIME1}};base64,{{kymw1709Model.imageFile1}}"
              [style.visibility]="kymw1709Model.imageFile1 ? 'visible' : 'hidden'">
          </div>
          
          <div class="element-column" [style.display]="kymw1709Model.imageFile2 ? 'flex' : 'none'">
            <div class="column-list">
              <label class="list-input-title">画像ファイル名</label>
              <div class="list-input-content">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imageFileName2">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imagePixel2">
              </div>
            </div>
            <img id="img_PastImage" src="data:image/{{kymw1709Model.imageFileMIME2}};base64,{{kymw1709Model.imageFile2}}">
          </div>
          
          <div class="element-column" [style.display]="kymw1709Model.imageFile3 ? 'flex' : 'none'">
            <div class="column-list">
              <label class="list-input-title">画像ファイル名</label>
              <div class="list-input-content">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imageFileName3">
                <input type="text" readonly [(ngModel)]="kymw1709Model.imagePixel3">
              </div>
            </div>
            <img id="img_PastImage" src="data:image/{{kymw1709Model.imageFileMIME3}};base64,{{kymw1709Model.imageFile3}}">
          </div>
          
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>